import React from "react";

// Import video files
import driveOrDieVideo from "../vids/DriveOrDieShowcase.mp4";
import ageOfSnailsVideo from "../vids/AgeOfSnailsCompressed.mp4";
import dashingJoyVideo from "../vids/DashingJoyShowcase.mp4";
import dungeonHallsVideo from "../vids/DungeonsHallCompressed.mp4";
import grinchmasVideo from "../vids/SmallerGrinchmasVid.mp4";
import miniMeVideo from "../vids/MiniMeCompressed.mp4";
import projectXVideo from "../vids/ProjectXCompressed.mp4";

// Import Drive or Die assets
import driveOrDieThumbnail from "../img/DriveOrDie/DriveOrDieThumbnail.png";
import driveOrDieVideoThumbnail from "../img/DriveOrDie/ThumbnailDriveOrDie.jpg";
import driveOrDieMapGif from "../vids/DriveOrDieMap.gif";
import driveOrDieVfxGif from "../vids/DriveOrDieVFXShowcase.gif";
import driveOrDieZombiesGif from "../vids/DriveOrDieZombiesShowcase.gif";
import driveOrDieCar2 from "../img/DriveOrDie/car2.png";
import driveOrDieIngame1 from "../img/DriveOrDie/Ingame.png";
import driveOrDieIngame2 from "../img/DriveOrDie/Ingame2.png";
import driveOrDiePlains from "../img/DriveOrDie/Plains.png";

// Import Age of Snails assets
import ageOfSnailsThumbnail from "../img/AgeOfSnails/AgeOfSnailsThumbnail.png";
import ageOfSnailsVideoThumbnail from "../img/AgeOfSnails/VidThumbnail.jpg";
import ageOfSnailsTimeGif from "../img/AgeOfSnails/AgeOfSnailsTime.gif";
import ageOfSnailsMoveGif from "../img/AgeOfSnails/AgeOfSnailsMove.gif";
import ageOfSnailsLeaderGif from "../img/AgeOfSnails/AgeOfSnailsLeader.gif";
import ageOfSnailsEnvironment1 from "../img/AgeOfSnails/environment.png";
import ageOfSnailsEnvironment2 from "../img/AgeOfSnails/enviroment.png";
import ageOfSnailsPumpkin from "../img/AgeOfSnails/pumpkin.png";
import ageOfSnailsPumpkin2 from "../img/AgeOfSnails/pumpkin2.png";

// Import Dashing Joy assets
import dashingJoyThumbnail from "../img/DashingJoy/ThumbnailWebsite.png";
import dashingJoyVideoThumbnail from "../img/DashingJoy/DashingJoyThumbnail.jpg";
import dashingJoyWaveGif from "../img/DashingJoy/WaveDisplayer.gif";
import dashingJoyCoinGif from "../img/DashingJoy/CoinDisplayer.gif";
import dashingJoyShopGif from "../img/DashingJoy/ShopDisplayer.gif";
import dashingJoySkins from "../img/DashingJoy/Skins.png";
import dashingJoyGold from "../img/DashingJoy/DashingJoyGold.png";

// Import Dungeon Halls assets
import dungeonHallsThumbnail from "../img/DungeonHalls/ThumbnailDungeonHalls.png";
import dungeonHallsVideoThumbnail from "../img/DungeonHalls/thumbnail.png";
import dungeonHallsEnvironment1 from "../img/DungeonHalls/Environment.png";
import dungeonHallsEnvironment2 from "../img/DungeonHalls/Environmen2.png";
import dungeonHallsPuzzle from "../img/DungeonHalls/Puzzle.png";
import dungeonHallsPuzzleEnding from "../img/DungeonHalls/PuzzleEnding.png";
import dungeonHallsEnemies from "../img/DungeonHalls/enemies.png";
import dungeonHallsUI from "../img/DungeonHalls/UI.png";
import dungeonHallsThumbnail2 from "../img/DungeonHalls/thumbnail2.png";

// Import Glitch Burst assets
import glitchBurstThumbnail from "../img/GlitchBurst/ThumbnailWebsite.png";
import glitchBurstSneakPeak from "../img/GlitchBurst/GlitchBurstSneakPeak.gif";

// Import Grinchmas assets
import grinchmasThumbnail from "../img/Grinchmas/ThumbnailWebsite.png";
import grinchmasVideoThumbnail from "../img/Grinchmas/VidCover.jpg";
import grinchmasWalkGif from "../img/Grinchmas/GrinchmasWalk.gif";
import grinchmasVR from "../img/Grinchmas/vr.png";
import grinchmasModels from "../img/Grinchmas/Models.png";
import grinchmasChickenPOV from "../img/Grinchmas/ChickenPOV.png";
import grinchmasInsideView from "../img/Grinchmas/IsideLook.png";
import grinchmasFridge from "../img/Grinchmas/fridge.png";

// Import Mini Me assets
import miniMeThumbnail from "../img/MiniMe/EnemyDesign.png";
import miniMeVideoThumbnail from "../img/MiniMe/NewVidThumbnail.jpg";
import miniMeMapGif from "../img/MiniMe/MiniMeMapShowcase.gif";
import miniMeBossGif from "../img/MiniMe/MiniMeBossShowcase.gif";
import miniMeShootGif from "../img/MiniMe/MiniMeShootShowcase.gif";
import miniMePlayer from "../img/MiniMe/player.png";
import miniMeBullets from "../img/MiniMe/bullets.png";
import miniMeEnemyDesign2 from "../img/MiniMe/EnemyDesign2.png";
import miniMeEnemyDesign3 from "../img/MiniMe/EnemyDesign3.png";

// Import Project X assets
import projectXThumbnail from "../img/ProjectX/ProjectXCoverNEw.png";
import projectXVideoThumbnail from "../img/ProjectX/ThumbnailProjectX.jpg";
import projectXEntity1Gif from "../img/ProjectX/ProjectXEntity.gif";
import projectXEntity2Gif from "../img/ProjectX/ProjectXEntity2.gif";
import projectXPlayerGif from "../img/ProjectX/ProjectXPlayerMovement.gif";
import projectXShowcase1 from "../img/ProjectX/ProjectX_Envouirment2.png";
import projectXShowcase2 from "../img/ProjectX/Environment4.png";
import projectXShowcase3 from "../img/ProjectX/Enemy.png";
import projectXShowcase4 from "../img/ProjectX/Level1.png";

// Import World Evolution assets
import worldEvoThumbnail from "../img/WorldEvo/ThumbnailWebsite.png";
import worldEvoVideoThumbnail from "../img/WorldEvo/ThumbnailWorldEvo.jpg";
import worldEvoPlanetsGif from "../img/WorldEvo/WorldEvoPlanets.gif";
import worldEvoSatelliteGif from "../img/WorldEvo/WorldEvoSattelite.gif";
import worldEvoTasksGif from "../img/WorldEvo/WorldEvoTasks.gif";
import worldEvoTasks from "../img/WorldEvo/Tasks.png";
import worldEvoMissions from "../img/WorldEvo/Missions.png";
import worldEvoLab from "../img/WorldEvo/Lab.png";
import worldEvoSatellite from "../img/WorldEvo/Satellite.png";

// Import Triffids assets
import triffidsThumbnail from "../img/Triffids/TriffidsThumbnail.jpg";
import triffidsGif1 from "../img/Triffids/TriffidsDayAndNight.gif";
import triffidsGif2 from "../img/Triffids/TriffidsGameplay.gif";
import triffidsGif3 from "../img/Triffids/TriffidsModels.gif";
import triffidsImg1 from "../img/Triffids/TriffidsImg1.jpg";
import triffidsImg2 from "../img/Triffids/TriffidsImg2.jpg";
import triffidsImg3 from "../img/Triffids/TriffidsImg3.jpg";
import triffidsImg4 from "../img/Triffids/TriffidsImg4.jpg";
import triffidsVidThumbnail from "../img/Triffids/TriffidsVidThumbnail.jpg";

// Import Dont Leave Me assets
import dontLeaveMeThumbnail from "../img/DontLeaveMe/NewDontLeaveMeThumbnail.jpg";
import dontLeaveMeVideoThumbnail from "../img/DontLeaveMe/DontLeaveMeThumbnailNew.jpg";
import dontLeaveMeGif1 from "../img/DontLeaveMe/NewDontLeaveMeCorpseShowcase.gif";
import dontLeaveMeGif2 from "../img/DontLeaveMe/NewDontLeaveMeHandsSmallShowcase.gif";
import dontLeaveMeGif3 from "../img/DontLeaveMe/NewDontLeaveMeHorrorShowcase.gif";
import dontLeaveMeImg1 from "../img/DontLeaveMe/DontLeaveMeImg1.jpg";
import dontLeaveMeImg2 from "../img/DontLeaveMe/DontLeaveMeImg2.jpg";
import dontLeaveMeImg3 from "../img/DontLeaveMe/DontLeaveMeImg3.jpg";
import dontLeaveMeImg4 from "../img/DontLeaveMe/DontLeaveMeImg4.jpg";

// Import Eggventure assets
import eggventureThumbnail from "../img/EggVenture/NewEggventureThumbnail.jpg";
import eggventureVidThumbnail from "../img/EggVenture/EggventureVidThumbnail.jpg";
import eggventureGif1 from "../img/EggVenture/dont_break_the_egg_gif.gif";
import eggventureGif2 from "../img/EggVenture/fly_like_a_bird_gif.gif";
import eggventureGif3 from "../img/EggVenture/jump_like_a_pro_gif.gif";
import eggventureImg1 from "../img/EggVenture/EggVenturePicture1.jpg";
import eggventureImg2 from "../img/EggVenture/EggVenturePicture2.jpg";
import eggventureImg3 from "../img/EggVenture/EggVenturePicture3.jpg";
import eggventureImg4 from "../img/EggVenture/EggVenturePicture4.jpg";

// Import Placeholders assets
import placeHolderThumbnail from "../img/Placeholders/TempThumbnail.jpg";
import placeHolderGif from "../img/Placeholders/TempGif.jpg";
import placeHolderImage from "../img/Placeholders/TempPicture.jpg";

//Blueprint
class ProjectBlueprint extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.id,
      hidden: props.hidden || false,

      title: props.title || "Project Title",
      shortDescription: props.shortDescription || "Short project description.",
      tileThumbnail: props.tileThumbnail || "default-thumbnail.jpg",

      status: props.status || "Unknown",
      duration: props.duration || "Unknown",
      description: props.description || "No description available.",
      technologies: props.technologies || [],

      video: props.video || null,
      videoThumbnail: props.videoThumbnail || null,

      gifs: props.gifs || [],
      objectFit: props.objectFit || "contain",
      proudDescriptions: props.proudDescriptions || [],
      images: props.images || [],
      showcaseVideo: props.showcaseVideo || true,
    };
  }
}

// Project data array
const projects = [
  // Glitch Burst project
  {
    id: "glitch-burst",
    hidden: false,
    title: "Glitch Burst",
    shortDescription: "Coming Soon",
    tileThumbnail: glitchBurstThumbnail,
    status: "In Progress",
    duration: "TBD",
    description:
      "Glitch Burst is currently in development. More details coming soon!",
    technologies: ["Unity", "Blender"],
    video: null,
    videoThumbnail: glitchBurstSneakPeak,
    gifs: null,
    proudDescriptions: null,
    images: [],
    showcaseVideo: false,
  },

  //Drive or Die

  {
    id: "drive-or-die",
    hidden: false,
    title: "Drive Or Die",
    shortDescription: "Drive fast. Stay alive.",
    tileThumbnail: driveOrDieThumbnail,
    status: "Finished",
    duration: "30 Days",
    description:
      "Drive or Die is a high-speed survival game where every turn counts. Dodge danger, keep moving, and see how long you can make it on the road. Refuel when you can, run down zombies, and spend the coins you earn on car upgrades. How long can you survive?",
    technologies: ["Unity"],
    video: driveOrDieVideo,
    videoThumbnail: driveOrDieVideoThumbnail,
    gifs: [
      { src: driveOrDieVfxGif, title: "VFX Overview" },
      { src: driveOrDieMapGif, title: "Map Overview" },
      { src: driveOrDieZombiesGif, title: "Zombies" },
    ],
    proudDescriptions: [
      "In Drive or Die, I learned to create visual effects (VFX) using Unity's particle system. This project allowed me to enhance the game's visuals with dynamic effects, like explosions and debris when running over zombies. It was a rewarding experience that deepened my understanding of VFX in game development!",
      "In Drive or Die, I learned to create visual effects (VFX) using Unity's particle system. This project allowed me to enhance the game's visuals with dynamic effects, like explosions and debris when running over zombies. It was a rewarding experience that deepened my understanding of VFX in game development!",
      "In Drive or Die, I designed the zombies with cute, cartoonish animations. I focused on tiny movements that add personality, making the zombies both playful and engaging. These animations help bring the characters to life and enhance the fun of the game!",
    ],
    images: [
      { src: driveOrDieIngame1, altText: "In-game screenshot 1" },
      { src: driveOrDieIngame2, altText: "In-game screenshot 2" },
      { src: driveOrDiePlains, altText: "Plains environment" },
      { src: driveOrDieCar2, altText: "Car customization 2" },
    ],
  },

  //Dashing Joy

  {
    id: "dashing-joy",
    hidden: false,
    title: "Dashing Joy",
    shortDescription: "Tap your way through neon-lit circles",
    tileThumbnail: dashingJoyThumbnail,
    status: "Finished",
    duration: "14 Days",
    description:
      "Step into the glow with Dashing Joy! Tap your way through waves of neon-lit circles before time runs out. Each round gets faster and more intense, can you keep up? Earn points as you play, unlock stylish skins in the shop, and climb your way to the top. One mode, endless challenge. Pure tapping fun!",
    technologies: ["Unity"],
    video: dashingJoyVideo,
    videoThumbnail: dashingJoyVideoThumbnail,
    gifs: [
      { src: dashingJoyWaveGif, title: "Waves" },
      { src: dashingJoyShopGif, title: "Shop" },
      { src: dashingJoyCoinGif, title: "Coin Particle" },
    ],
    proudDescriptions: [
      "What I'm proud of in Dashing Joy is creating a simple but engaging game loop. The wave system gradually gets harder and faster, keeping players on their toes and making each round feel more intense without overcomplicating the gameplay.",
      "I also built a simple in-game shop where players can spend earned currency to unlock new skins. It's basic, but it taught me a lot about how shops work in games, from handling currency to switching cosmetics.",
      "I added a simple coin collection animation that plays when you lose a round, the coins you earned fly into your purse. It's a small touch, but it adds a satisfying sense of reward and helps give the game a more polished feel, even at the end of a run.",
    ],
    images: [
      { src: dashingJoySkins, altText: "Dashing Joy skins" },
      { src: dashingJoyGold, altText: "Dashing Joy gold version" },
    ],
  },

  //Mini Me

  {
    id: "mini-me",
    hidden: false,
    title: "Mini Me",
    shortDescription: "A 2D bullet-hell dungeon crawler",
    tileThumbnail: miniMeThumbnail,
    status: "Finished",
    duration: "30 Days",
    description:
      "Mini Me is a fun, action-packed 2D bullet-hell dungeon crawler where you play as a quick little purple ghost with some cool blue fire powers. You'll zip through tricky dungeons, dodging enemy bullets while hunting for keys to unlock new areas. Clear each room as fast as you can to score big and take on some wild multi-phase boss fights. With its retro pixel art and fast gameplay, it's a blast for anyone who loves a good challenge!",
    technologies: ["Unity"],
    video: miniMeVideo,
    videoThumbnail: miniMeVideoThumbnail,
    gifs: [
      { src: miniMeMapGif, title: "New Skills" },
      { src: miniMeBossGif, title: "Bullet script" },
      { src: miniMeShootGif, title: "Score system" },
    ],
    proudDescriptions: [
      "I learned to use Unity's new input system, which made player controls much smoother and more responsive. I also explored 2D lights for cool effects and depth, and got into the tilemap system with tile rules to streamline level design. It's really boosted both my creativity and efficiency!",
      "I made a cool script that simplifies bullet spawning! You just drop in a bullet prefab and set variables like angle, speed, size, and damage. If you want the bullet to aim at the player, it shoots straight at them, but if not, it shoots straight up. I also added a spawn delay to create a wave effect, so when you fire bullets at different times, it feels like multiple bullets are coming out at once. It really adds some nice dynamics to the gameplay!",
      "I implemented a score system with high scores based on enemy kills, doors opened, keys collected, and whether you defeat the boss. The faster you do it all, the higher your score! This adds a fun speedrun dynamic to the game, encouraging players to beat their best times while maximizing their points.",
    ],
    images: [
      { src: miniMePlayer, altText: "MiniMe player" },
      { src: miniMeBullets, altText: "MiniMe bullets" },
      { src: miniMeEnemyDesign2, altText: "MiniMe enemy design 2" },
      { src: miniMeEnemyDesign3, altText: "MiniMe enemy design 3" },
    ],
  },

  //Project X

  {
    id: "project-x",
    hidden: false,
    title: "Project X",
    shortDescription: "A surreal dimensional adventure",
    tileThumbnail: projectXThumbnail,
    status: "Finished",
    duration: "4 Weeks",
    description:
      "Project X is a surreal adventure where you play as a scientist pulled into a strange dimension after a particle accelerator accident. Trapped in a vast void of floating debris, you must leap between rocks to reach a portal. It leads to an old, abandoned library haunted by a creature that hunts you relentlessly. As you explore, you'll need to stay alert, hide when needed, and navigate the maze-like rooms to escape without being caught.",
    technologies: ["Unity"],
    video: projectXVideo,
    videoThumbnail: projectXVideoThumbnail,
    gifs: [
      { src: projectXEntity1Gif, title: "New Experience" },
      { src: projectXPlayerGif, title: "Player Movement" },
      { src: projectXEntity2Gif, title: "Sound Design" },
    ],
    proudDescriptions: [
      "Working on Project X was a great experience for me, especially since it was my first 3D project. I learned a lot about teamwork, and everything went really smoothly. We managed to pull it all together in just four weeks, which felt pretty fast! It was exciting to see how we all contributed our skills and ideas to create something awesome together.",
      "In Project X, I focused on creating a smooth player movement system. I implemented wall jumps and wall runs to enhance mobility, along with features like coyote time for jumping after leaving a ledge, crouching, running, and jumping. I also fine-tuned the camera effects and slope movement for a more dynamic gameplay experience. It was a fun challenge to make everything feel just right!",
      "In Project X, I took on the sound design, gathering and implementing all the audio elements for the game. I created sound effects for player movement, the monster, jumpscares, and ambient sounds to enhance the atmosphere. This process taught me how crucial sound is for creating an immersive experience, and I loved adding that extra layer of depth to the game!",
    ],
    images: [
      { src: projectXShowcase1, altText: "Project X environment 1" },
      { src: projectXShowcase2, altText: "Project X environment 2" },
      { src: projectXShowcase3, altText: "Project X ingame" },
      { src: projectXShowcase4, altText: "Project X level 1" },
    ],
  },

  //World Evolution

  {
    id: "world-evolution",
    hidden: false,
    title: "World Evolution",
    shortDescription: "An idle clicker evolution game",
    tileThumbnail: worldEvoThumbnail,
    status: "In Progress",
    duration: "1.5 Years",
    description:
      "World Evolution is an idle clicker game where you guide Earth from a lava-filled beginning to a vibrant world of life. Upgrade your satellite for passive income, unlock creatures for bonuses, and complete quests to speed up evolution. Click your way from the dawn of life to the age of dinosaurs and beyond!",
    technologies: ["Unity"],
    video: null,
    videoThumbnail: worldEvoVideoThumbnail,
    gifs: [
      { src: worldEvoPlanetsGif, title: "From Scratch" },
      { src: worldEvoTasksGif, title: "Missions" },
      { src: worldEvoSatelliteGif, title: "Determination" },
    ],
    objectFit: "cover",
    proudDescriptions: [
      "Creating World Evolution was my first big project, and it became my playground for learning to code from the ground up. I built everything from scratch, learning a ton along the way. Every few months, I'd look back at my early work and think, 'This could be way better!'—which led to a lot of redesigns and improvements over 1.5 years.",
      "I designed an adaptable mission system that makes creating new missions easy and flexible. Each mission has three tasks to level up, and once all reach level 10, the mission is complete, unlocking the next stage of World Evolution. Using indexed arrays, I can set up and customize missions quickly for each phase.",
      "Working on World Evolution for 1.5 years has been a true test of my determination. Despite the challenges and constant learning curves, I stayed committed to bringing this project to life. Each setback only motivated me to improve and taught me the value of persistence in game development.",
    ],
    images: [
      { src: worldEvoTasks, altText: "World Evolution tasks UI" },
      { src: worldEvoMissions, altText: "World Evolution mission screen" },
      { src: worldEvoLab, altText: "World Evolution lab" },
      { src: worldEvoSatellite, altText: "World Evolution satellite" },
    ],
  },

  //Age of Snails

  {
    id: "age-of-snails",
    hidden: false,
    title: "Age of Snails",
    shortDescription: "A horror twist on snail jousting",
    tileThumbnail: ageOfSnailsThumbnail,
    status: "Game Jam",
    duration: "12.5 Hours",
    description:
      "Age of Snails is a horror twist on snail jousting set in a dark forest. Armed with a spear, you must collect 10 pumpkins while fending off aggressive snails that also have spears. Aim quickly to joust them away, or face defeat! The more pumpkins you gather, the more snails spawn, adding to the challenge. With jumpscares and a creepy atmosphere, this thrilling game was created in just 12.5 hours during a game jam!",
    technologies: ["Unity"],
    video: ageOfSnailsVideo,
    videoThumbnail: ageOfSnailsVideoThumbnail,
    gifs: [
      { src: ageOfSnailsTimeGif, title: "Time Pressure" },
      { src: ageOfSnailsMoveGif, title: "Actual Tasks" },
      { src: ageOfSnailsLeaderGif, title: "Project Leader" },
    ],
    proudDescriptions: [
      "Working on Age of Snails under a tight 12.5-hour deadline was a thrilling challenge. Our team communicated effectively, dividing tasks based on our strengths and holding quick check-ins to stay aligned. Despite the pressure, we collaborated well, brainstorming ideas and solving issues together. This teamwork made the process enjoyable and helped us create a cohesive game in a short time!",
      "I focused on several key tasks, including player movement, sound design, and UI. I implemented smooth player controls to enhance the gameplay experience and added sound effects to elevate the horror atmosphere. Additionally, I worked on the user interface to keep players informed and engaged. I also set up the enemy spawning system, which added to the challenge and excitement of the game.",
      "In Age of Snails, I took on the role of the project glue, ensuring that all elements of the game worked together seamlessly. I coordinated the interactions between the map, enemies, and pumpkins, making sure they all functioned properly with the player. This role was crucial in creating a cohesive experience, allowing our team's creative ideas to come together effectively during our limited time.",
    ],
    images: [
      { src: ageOfSnailsEnvironment1, altText: "Age of Snails environment 1" },
      { src: ageOfSnailsEnvironment2, altText: "Age of Snails environment 2" },
      { src: ageOfSnailsPumpkin, altText: "Age of Snails pumpkin" },
      { src: ageOfSnailsPumpkin2, altText: "Age of Snails pumpkin 2" },
    ],
  },

  // Triffids

  {
    id: "triffids",
    hidden: false,
    title: "Triffids",
    shortDescription: "A fast-paced 3D shooter about destroying killer flora.",
    tileThumbnail: triffidsThumbnail,
    status: "Finished",
    duration: "8 Days",
    description:
      "The Day of the Triffids is a fast, intense 3D shooter where you battle swarms of hostile plants. You and your baby plant share the same health if one falls, you both do. Hunt enemies by day, defend your plant by night, and feed it the energy you collect to level up together. With flashy VFX, punchy gunplay, and a satisfying power curve, it’s an addictive fight for survival against nature itself.",
    technologies: ["Unity", "Blender"],
    video: null,
    showcaseVideo: false,
    videoThumbnail: triffidsVidThumbnail,
    gifs: [
      { src: triffidsGif3, title: "The Flora Models" },
      { src: triffidsGif2, title: "The Gun Feel & Gameplay Flow" },
      { src: triffidsGif1, title: "The 8-Day Challenge" },
    ],
    proudDescriptions: [
      "I created all the plant enemies myself, and I’m proud of how alive and unique they feel. Their designs and animations really help set the game’s atmosphere.",
      "The shooting feels powerful and responsive, with great feedback and pacing. It makes the action smooth, fun, and surprisingly addictive.",
      "Finishing the whole game in just eight days was intense, but super rewarding. I’m proud of how polished and fun it turned out in such a short time.",
    ],
    images: [
      { src: triffidsImg1, altText: "TriffidsGame1" },
      { src: triffidsImg2, altText: "TriffidsGame2" },
      { src: triffidsImg3, altText: "TriffidsGame3" },
      { src: triffidsImg4, altText: "TriffidsMonsterDesign" },
    ],
  },

  // Dont Leave Me

  {
    id: "dont-leave-me",
    hidden: false,
    title: "Dont Leave Me",
    shortDescription:
      "A 3D horror puzzle game where leaving the body means death.",
    tileThumbnail: dontLeaveMeThumbnail,
    status: "Finished",
    duration: "7 Days",
    description:
      "Don’t Leave Me is a chilling 3D horror game where you wake up beside a dead body and you can’t leave it behind. Step too far away, and you die. You’ll navigate an alien, dreamlike dimension filled with eerie puzzles, strange noises, and sudden scares. With heavy atmosphere, haunting visuals, and constant tension, it delivers that uneasy feeling that something’s always watching.",
    technologies: ["Unity", "Blender"],
    video: null,
    showcaseVideo: false,
    videoThumbnail: dontLeaveMeVideoThumbnail,
    objectFit: "cover",
    gifs: [
      { src: dontLeaveMeGif1, title: "The Dead Body Model" },
      { src: dontLeaveMeGif2, title: "The Polished Feel" },
      { src: dontLeaveMeGif3, title: "The 7-Day Challenge" },
    ],
    proudDescriptions: [
      "I’m really proud of how the body turned out. It’s detailed and unsettling, adding a strong visual focus and a lot of tension to every scene.",
      "For a short project, the game feels smooth and complete. The pacing, visuals, and atmosphere all blend perfectly to make the experience immersive and genuinely scary.",
      "Creating the whole game in just seven days was intense, but I’m proud of how much I achieved. Despite the short window, the result feels focused, polished, and true to the horror vision I had.",
    ],
    images: [
      { src: dontLeaveMeImg1, altText: "MiniMe player" },
      { src: dontLeaveMeImg2, altText: "MiniMe bullets" },
      { src: dontLeaveMeImg4, altText: "MiniMe enemy design 2" },
      { src: dontLeaveMeImg3, altText: "MiniMe enemy design 3" },
    ],
  },

  // Eggventure

  {
    id: "eggventure",
    hidden: false,
    title: "Eggventure",
    shortDescription: "A 3D platformer with a hatching twist.",
    tileThumbnail: eggventureThumbnail,
    status: "Finished",
    duration: "32 Hours",
    description:
      "Eggventure is a colorful 3D platformer where you roll through a vibrant world as a fragile egg on a journey to hatch and evolve. Start by simply rolling and maneuvering through lush forests, then reach your first nest to hatch wings and learn to flap and jump. Later, you’ll grow legs and take full control as you explore new areas. With smooth mechanics, polished visuals, and a touch of rage-bait challenge, it’s a fun and quirky adventure from start to finish.",
    technologies: ["Unity", "Blender"],
    video: null,
    showcaseVideo: false,
    videoThumbnail: eggventureVidThumbnail,
    gifs: [
      { src: eggventureGif1, title: "The Models, Animations & Polish" },
      { src: eggventureGif2, title: "The Teamwork & Aesthetics" },
      { src: eggventureGif3, title: "The 32-Hour Challenge" },
    ],
    proudDescriptions: [
      "I’m really proud of how the models and animations came together. The hatching stages look smooth and natural, and the world feels lively and full of detail.",
      "Everyone on the team contributed something great, and it really shows. The art, sound, and design all blend perfectly into a cohesive, charming style.",
      "We made Eggventure in just 32 hours for a game jam. Despite the short window, it turned out incredibly polished, fun to play, and surprisingly addictive.",
    ],
    images: [
      { src: eggventureImg1, altText: "MiniMe player" },
      { src: eggventureImg2, altText: "MiniMe bullets" },
      { src: eggventureImg3, altText: "MiniMe enemy design 2" },
      { src: eggventureImg4, altText: "MiniMe enemy design 3" },
    ],
  },

  // Sugar Rush

  {
    id: "sugar-rush",
    hidden: true,
    title: "Sugar Rush",
    shortDescription: "A fast-paced 3D rolling cookie racer.",
    tileThumbnail: placeHolderImage,
    status: "Finished",
    duration: "3 Days",
    description:
      "Sugar Rush is a high-speed 3D action game where you control a rolling cookie through a vibrant candy world. Inspired by Haste, you’ll race, dodge obstacles like lollipops and marshmallows, and try to keep up your speed to break records and set the high score. Time your boosts perfectly to maintain momentum, survive tricky terrain, and reach the portal at the end for ultimate satisfaction. Everything is handmade for maximum reward, speed, and fun!",
    technologies: ["Unity"],
    video: null,
    showcaseVideo: false,
    videoThumbnail: placeHolderThumbnail,
    gifs: [
      { src: placeHolderGif, title: "The Cookie Model" },
      { src: placeHolderGif, title: "The Speed & Game Feel" },
      { src: placeHolderGif, title: "The End Portal" },
    ],
    proudDescriptions: [
      "I’m really proud of how the cookie turned out it’s cute, expressive, and fits perfectly in the colorful candy world.",
      "The game’s movement feels super fast and rewarding. Rolling, boosting, and maintaining speed all come together to create a thrilling, adrenaline-pumping experience.",
      "The portal at the end was a highlight for me. I feel like I nailed the design and visual impact, making the finish line feel epic and satisfying.",
    ],
    images: [
      { src: placeHolderImage, altText: "MiniMe player" },
      { src: placeHolderImage, altText: "MiniMe bullets" },
      { src: placeHolderImage, altText: "MiniMe enemy design 2" },
      { src: placeHolderImage, altText: "MiniMe enemy design 3" },
    ],
  },

  // Worm of the Warp

  {
    id: "worm-of-the-warp",
    hidden: true,
    title: "Worm of the Warp",
    shortDescription: "A 3D space shooter with custom Arduino tilt controls.",
    tileThumbnail: placeHolderImage,
    status: "Finished",
    duration: "20 Days",
    description:
      "Worm of the Warp is a 3D space shooter where you pilot a ship through the stars to face a colossal space leviathan. Controlled by a custom Arduino setup with gyroscopic tilt, it delivers a unique and immersive flying experience. Dodge comets, fire from both wings, and battle your way through space to destroy the leviathan emerging from its portal. With striking visuals, dynamic sound, and a creative control system, it’s a short but unforgettable adventure.",
    technologies: ["Unity"],
    video: null,
    showcaseVideo: false,
    videoThumbnail: placeHolderThumbnail,
    gifs: [
      { src: placeHolderGif, title: "The Space Leviathan" },
      { src: placeHolderGif, title: "Learning Arduino Basics" },
      { src: placeHolderGif, title: "The Portal & Sound Design" },
    ],
    proudDescriptions: [
      "I built the leviathan from scratch and made it fully functional. Watching it come to life in-game was an awesome moment.",
      "Even though my teammate handled most of the setup, I learned the essentials of Arduino and how the gyroscope connects gameplay to physical movement.",
      "The portal the leviathan spawns from turned out great paired with the sound design, it makes the final battle feel intense and cinematic.",
    ],
    images: [
      { src: placeHolderImage, altText: "MiniMe player" },
      { src: placeHolderImage, altText: "MiniMe bullets" },
      { src: placeHolderImage, altText: "MiniMe enemy design 2" },
      { src: placeHolderImage, altText: "MiniMe enemy design 3" },
    ],
  },

  // Consumed by Light

  {
    id: "consumed-by-light",
    hidden: true,
    title: "Consumed by Light",
    shortDescription: "A demonic 3D wave shooter.",
    tileThumbnail: placeHolderImage,
    status: "Finished",
    duration: "8 Days",
    description:
      "Consumed by Light is a fast-paced 3D action wave shooter where you play as a demon who’s taken over a holy church. As God sends waves of priests, paladins, and angels to reclaim it, you fight back with a hand-shotgun and telekinetic powers that let you fling enemies across the room. Survive as long as possible while light and darkness collide in a chaotic, visually striking battle for control.",
    technologies: ["Unity"],
    video: null,
    showcaseVideo: false,
    videoThumbnail: placeHolderThumbnail,
    gifs: [
      { src: placeHolderGif, title: "Full In-House Creation" },
      { src: placeHolderGif, title: "Enemy Behaviors & Animations" },
      { src: placeHolderGif, title: "Leading the Team" },
    ],
    proudDescriptions: [
      "Everything in the game models, animations, VFX, and lighting was made by our team. Seeing it all come together from scratch was incredibly rewarding.",
      "I created all the enemy logic and animations, making each wave feel distinct and alive. Every encounter pushes the gameplay forward and keeps it exciting.",
      "I served as team lead, organizing the project with scrum boards and managing our workflow. It taught me a lot about coordination, leadership, and staying focused under pressure.",
    ],
    images: [
      { src: placeHolderImage, altText: "MiniMe player" },
      { src: placeHolderImage, altText: "MiniMe bullets" },
      { src: placeHolderImage, altText: "MiniMe enemy design 2" },
      { src: placeHolderImage, altText: "MiniMe enemy design 3" },
    ],
  },

  // Studio Adventure

  {
    id: "studio-adventure",
    hidden: true,
    title: "Studio Adventure",
    shortDescription: "A cozy point-and-click studio builder.",
    tileThumbnail: placeHolderImage,
    status: "Finished",
    duration: "7 Days",
    description:
      "Studio Adventure is a relaxing point-and-click game where you play as the head of Studio Tast. Complete small interactive tasks like stopping the water when the tank fills or dragging items from a desk into a box to keep your studio running smoothly. Each task brings you closer to building up the full studio, piece by piece, until it’s complete in all its glory. It’s simple, satisfying, and full of creative charm.",
    technologies: ["Unity"],
    video: null,
    showcaseVideo: false,
    videoThumbnail: placeHolderThumbnail,
    gifs: [
      { src: placeHolderGif, title: "Task Design & Flow" },
      { src: placeHolderGif, title: "Studio Progression" },
      { src: placeHolderGif, title: "The Overall Polish" },
    ],
    proudDescriptions: [
      "Designing fun, varied mini-tasks that feel rewarding to complete made the game engaging and easy to enjoy.",
      "Watching the studio come to life as you finish each challenge feels great it gives a clear sense of growth and accomplishment.",
      "I’m proud of how clean and satisfying the experience feels. The visuals, feedback, and pacing all come together into a smooth, cozy experience.",
    ],
    images: [
      { src: placeHolderImage, altText: "MiniMe player" },
      { src: placeHolderImage, altText: "MiniMe bullets" },
      { src: placeHolderImage, altText: "MiniMe enemy design 2" },
      { src: placeHolderImage, altText: "MiniMe enemy design 3" },
    ],
  },

  // Block Beats

  {
    id: "block-beats",
    hidden: true,
    title: "Block Beats",
    shortDescription: "A rhythm game with dynamic beat mapping.",
    tileThumbnail: placeHolderImage,
    status: "Finished",
    duration: "10 Days",
    description:
      "Block Beats is a fast-paced rhythm game inspired by Guitar Hero, where you hit buttons in time with tiles landing on their panels. What makes it special is its dynamic system tiles are generated automatically using real audio analysis, matching every beat of any song you play. Built with JavaScript and THREE.js, it delivers a smooth, energetic experience that syncs perfectly with the music.",
    technologies: ["Unity"],
    video: null,
    showcaseVideo: false,
    videoThumbnail: placeHolderThumbnail,
    gifs: [
      { src: placeHolderGif, title: "The Dynamic Tile System" },
      { src: placeHolderGif, title: "Learning JavaScript & THREE.js" },
      { src: placeHolderGif, title: "The 1.5-Week Challenge" },
    ],
    proudDescriptions: [
      "I built a complex algorithm that reads audio data and spawns tiles exactly on the beat. It works with any track and makes the gameplay feel perfectly synced to the music.",
      "This was my first time using JavaScript and THREE.js, and I’m really proud of how quickly I learned and applied them to build a full rhythm game.",
      "Creating everything in just a week and a half was intense, but I managed to get it polished, responsive, and genuinely fun to play.",
    ],
    images: [
      { src: placeHolderImage, altText: "MiniMe player" },
      { src: placeHolderImage, altText: "MiniMe bullets" },
      { src: placeHolderImage, altText: "MiniMe enemy design 2" },
      { src: placeHolderImage, altText: "MiniMe enemy design 3" },
    ],
  },

  // Egg With Your Friends

  {
    id: "egg-with-your-friends",
    hidden: true,
    title: "Egg With Your Friends",
    shortDescription: "A rhythm-based puzzle game",
    tileThumbnail: placeHolderImage,
    status: "Finished",
    duration: "8 Days",
    description:
      "Triffids is a fun, action-packed 2D bullet-hell dungeon crawler where you play as a quick little purple ghost with some cool blue fire powers. You'll zip through tricky dungeons, dodging enemy bullets while hunting for keys to unlock new areas. Clear each room as fast as you can to score big and take on some wild multi-phase boss fights. With its retro pixel art and fast gameplay, it's a blast for anyone who loves a good challenge!",
    technologies: ["Unity"],
    video: null,
    showcaseVideo: false,
    videoThumbnail: placeHolderThumbnail,
    gifs: [
      { src: placeHolderGif, title: "New Skills" },
      { src: placeHolderGif, title: "Bullet script" },
      { src: placeHolderGif, title: "Score system" },
    ],
    proudDescriptions: [
      "I learned to use Unity's new input system, which made player controls much smoother and more responsive. I also explored 2D lights for cool effects and depth, and got into the tilemap system with tile rules to streamline level design. It's really boosted both my creativity and efficiency!",
      "I made a cool script that simplifies bullet spawning! You just drop in a bullet prefab and set variables like angle, speed, size, and damage. If you want the bullet to aim at the player, it shoots straight at them, but if not, it shoots straight up. I also added a spawn delay to create a wave effect, so when you fire bullets at different times, it feels like multiple bullets are coming out at once. It really adds some nice dynamics to the gameplay!",
      "I implemented a score system with high scores based on enemy kills, doors opened, keys collected, and whether you defeat the boss. The faster you do it all, the higher your score! This adds a fun speedrun dynamic to the game, encouraging players to beat their best times while maximizing their points.",
    ],
    images: [
      { src: placeHolderImage, altText: "MiniMe player" },
      { src: placeHolderImage, altText: "MiniMe bullets" },
      { src: placeHolderImage, altText: "MiniMe enemy design 2" },
      { src: placeHolderImage, altText: "MiniMe enemy design 3" },
    ],
  },

  //
  // Hidden Projects //
  //

  //Dungeon Halls

  {
    id: "dungeon-halls",
    hidden: true,
    title: "Dungeon Halls",
    shortDescription: "An undead dungeon crawler",
    tileThumbnail: dungeonHallsThumbnail,
    status: "Finished",
    duration: "4 Weeks",
    description:
      "Dungeon Halls is an undead dungeon crawler where you battle skeletons using spells like sword summoning and icy projectiles. Find three hidden runes to unlock the final room, complete parkour challenges over lava, and match the runes to win the crown. Can you outsmart the skeletons and escape?",
    technologies: ["Unity"],
    video: dungeonHallsVideo,
    videoThumbnail: dungeonHallsVideoThumbnail,
    gifs: [
      { src: dungeonHallsEnemies, title: "Enemy Development" },
      { src: dungeonHallsThumbnail2, title: "Sound Design" },
      { src: dungeonHallsUI, title: "UI Design" },
    ],
    proudDescriptions: [
      "In Dungeon Halls, I focused on creating the enemies for my second 3D project. I designed their attack and shooting animations, making sure they felt dynamic and engaging during battles. Additionally, I implemented a spawning system to bring the skeletons into the dungeon, enhancing the gameplay experience. It was exciting to see my work come to life and challenge players as they navigated the castle!",
      "In Dungeon Halls, I took charge of the sound design once again. I created and implemented various sound effects for the enemies, spellcasting, and the environment to enhance the immersive experience. From the clashing of weapons to the eerie ambiance of the dungeon, I aimed to make every moment feel alive and engaging for players.",
      "In Dungeon Halls, I designed the user interface, including the main menu, game over screen, and health bar. My aim was to create a clear and engaging layout that kept players informed without distracting from the gameplay. The UI enhances the overall experience, allowing players to focus on their adventure in the dungeon while easily tracking their progress and health.",
    ],
    images: [
      { src: dungeonHallsEnvironment1, altText: "Dungeon Halls environment 1" },
      { src: dungeonHallsEnvironment2, altText: "Dungeon Halls environment 2" },
      { src: dungeonHallsPuzzle, altText: "Dungeon Halls puzzle" },
      { src: dungeonHallsPuzzleEnding, altText: "Dungeon Halls puzzle ending" },
    ],
  },

  //Grinchmas

  {
    id: "grinchmas",
    hidden: true,
    title: "Grinchmas",
    shortDescription: "A fast-paced 3D VR cooking game",
    tileThumbnail: grinchmasThumbnail,
    status: "Finished",
    duration: "30 Days",
    description:
      "Grinchmas is a fast-paced 3D VR cooking game where you have to make dinner before time runs out. If you don't finish in time, the Grinch shows up and you'll never cook again. But if you pull it off, your family gets to eat and you're safe. It's fun, frantic, and just the right amount of weird.",
    technologies: ["Unity", "Blender"],
    video: grinchmasVideo,
    videoThumbnail: grinchmasVideoThumbnail,
    gifs: [
      { src: grinchmasVR, title: "VR" },
      { src: grinchmasModels, title: "Models" },
      { src: grinchmasWalkGif, title: "Holiday Vibe" },
    ],
    proudDescriptions: [
      "I also learned the basics of VR while working on Grinchmas, which was a whole new challenge for me. Setting up interactions and making everything work in a 3D space took a lot of trial and error, but it was a great learning experience. Even though it was frustrating at times, finally getting things to work felt amazing!",
      "I'm really proud of making all the models and assets for Grinchmas. It was my first time using Blender and the first project where I handled all the modeling myself. It was a big step for me, and seeing everything come together in the game was super rewarding. Even though the VR side gave me a hard time, pushing through those challenges made the end result feel even more worth it.",
      "Making Grinchmas was a lot of fun, especially building all the models and assets. I really enjoyed bringing the weird holiday vibe to life. The VR part, though, was a bit of a nightmare. Getting everything to work properly took way more time than I expected, but I learned a ton along the way.",
    ],
    images: [
      { src: grinchmasChickenPOV, altText: "Grinchmas chicken POV" },
      { src: grinchmasInsideView, altText: "Grinchmas inside view" },
      { src: grinchmasFridge, altText: "Grinchmas fridge" },
    ],
  },
];

export const projectsData = projects;

export default ProjectBlueprint;
